//eslint-disable-next-line
export const PACKAGING_GROUP_MARGIN_REGEX = /^(-)?\d{1,3}\d((\.|\,)\d\d?)?$/;
export const MINIMUM_PACKAGING_DRIVER_ALLOCATION_VALUE = -100;
export const MAXIMUM_PACKAGING_DRIVER_ALLOCATION_VALUE = 100;
